// extracted by mini-css-extract-plugin
export var label = "label-module--label--95303";